// extracted by mini-css-extract-plugin
export default {"wrap":"eN-z","fullWidth":"fN-z","hideOnDesktop":"gN-z","content":"hN-z","hasOpenedNav":"iN-z","crumbsList":"jN-z","dropdownsWrap":"kN-z"};